<template>
  <div class='pt-2 mr-5'>
    <div class='d-flex'>
      <span class='subtitle-1 text-uppercase text-left'
        :class='hiddenSelectedWOs ? "error--text" : ""'>Unscheduled</span>
      <span v-if='hiddenSelectedWOs' class='ml-2'>
        <v-tooltip top :open-delay='500'>
          <template v-slot:activator='{ on }'>
            <v-icon v-on='on' color='error' class='mt-n2'>mdi-alert</v-icon>
          </template>
          <span class='caption'>Caution - You have selected WOs that are hidden by filters!</span>
        </v-tooltip>
      </span>
      <v-spacer></v-spacer>
      <span class='ml-auto mt-1 text-right body-2 success--text'>{{ routeRevenue | intMoney }}</span>
    </div>
    <table width='100%'>
      <tr>
        <td>
          <v-tooltip top :open-delay='500'>
            <template v-slot:activator='{ on }'>
              <div v-on='on' class='d-inline-block'>
                <v-btn x-small :disabled='sortedWOs.length > 20 || !!search.length' icon @click="selectAll">
                  <!-- :disabled='isLoading || !!search.length' -->
                  <v-icon small>mdi-checkbox-marked-outline</v-icon>
                </v-btn>
              </div>
            </template>
            <span v-if='sortedWOs.length > 20 && !search.length' class='caption'>Select All - disabled if more than one
              page</span>
            <span v-if='sortedWOs.length <= 20 && !search.length' class='caption'>
              {{ 'Select all ' + sortedWOs.length + 'visible WOs' }}</span>
            <span v-if='search.length' class='caption'>WOs filtered by search must be individually selected</span>
          </v-tooltip>

          <v-tooltip top :open-delay='500'>
            <template v-slot:activator='{ on }'>
              <v-btn v-on='on' x-small :disabled='isLoading' icon @click="deselectAll">
                <v-icon small>mdi-checkbox-blank-outline</v-icon>
              </v-btn>
            </template>
            <span class='caption'>Deselect All</span>
          </v-tooltip>

          <v-tooltip top :open-delay='500'>
            <template v-slot:activator='{ on }'>
              <div v-on='on' class='d-inline-block'>
                <v-btn x-small :disabled='isLoading || !$store.state.schedule.selectedWOs.length' icon
                  @click="$emit('moveWOs')">
                  <v-icon small>mdi-calendar-remove</v-icon>
                </v-btn>
              </div>
            </template>
            <span class='caption'>Unschedule the selected work orders</span>
            <span v-if='!$store.state.schedule.selectedWOs.length' class='caption ml-1'>(no wos are currently
              selected)</span>
          </v-tooltip>

        </td>
        <td class="text-right">
          <v-tooltip top :open-delay='500'>
            <template v-slot:activator='{ on }'>
              <v-btn v-on='on' x-small :disabled='isLoading' icon @click='resetList'>
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span class='caption'>Clear all filters/search</span>
          </v-tooltip>

          <v-tooltip top :open-delay='500'>
            <template v-slot:activator='{ on }'>
              <v-btn v-on='on' x-small :disabled='isLoading' icon @click='filterParkingLot'>
                <v-icon small :color="filterByParkingLot ? 'error' : ''">mdi-parking</v-icon>
              </v-btn>
            </template>
            <span class='caption'>Filter By Parking Lot</span>
          </v-tooltip>
          <v-tooltip top :open-delay='500'>
            <template v-slot:activator='{ on }'>
              <v-btn v-on='on' x-small :disabled='isLoading' icon @click='filterCommercial'>
                <v-icon small :color="filterByCommercial ? 'error' : ''">mdi-domain</v-icon>
              </v-btn>
            </template>
            <span class='caption'>Filter Commercial</span>
          </v-tooltip>

          <v-menu offset-y dense bottom :close-on-content-click='false' :value='showSearch'>
            <template v-slot:activator='{ on: menu }'>
              <v-tooltip top :open-delay='500'>
                <template v-slot:activator='{ on: tooltip }'>
                  <v-btn v-on='{ ...tooltip, ...menu }' x-small icon :disabled='isLoading' @click='openSearch'>
                    <v-icon small :color="search.length ? 'red' : ''">mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span v-if='!search.length' class='caption'>Search by name or address</span>
                <span v-else class='caption'>Search filter is active</span>
              </v-tooltip>
            </template>
            <span>
              <wc-data-box hideToolbar>
                <v-text-field class='mx-3' ref='search' placeholder='Search' prepend-inner-icon='mdi-magnify'
                  v-model='search' append-icon='mdi-close' @click:append='closeSearch' :hint='searchHint'
                  persistent-hint>
                </v-text-field>
              </wc-data-box>
            </span>
          </v-menu>

          <v-menu offset-y bottom :close-on-content-click='false' :value='showRouteGroupPicker'>
            <template v-slot:activator='{ on: menu }'>
              <v-tooltip top :open-delay='500'>
                <template v-slot:activator='{ on: tooltip }'>
                  <v-btn v-on='{ ...tooltip, ...menu }' x-small icon :disabled='isLoading'
                    @click='showRouteGroupPicker = true'>
                    <v-icon small
                      :color="selectedRouteGroups.length > 0 ? 'red' : ''">mdi-sort-alphabetical-variant</v-icon>
                  </v-btn>
                </template>
                <span v-if='!selectedRouteGroups.length' class='caption'>Filter by route group</span>
                <span v-else class='caption'>Route filter is active</span>
              </v-tooltip>
            </template>
            <v-card tile>
              <v-card-text>
                <v-combobox v-model='selectedRouteGroups' :items='pickableRouteGroups' label='Only show route groups:'
                  multiple small-chips clearable></v-combobox>
              </v-card-text>
            </v-card>
          </v-menu>

          <v-menu offset-y bottom :close-on-content-click='false' :value='showWOPicker'>
            <template v-slot:activator='{ on: menu }'>
              <v-tooltip top :open-delay='500'>
                <template v-slot:activator='{ on: tooltip }'>
                  <v-btn v-on='{ ...tooltip, ...menu }' x-small icon :disabled='isLoading' @click='showWOPicker = true'>
                    <v-icon small :color="selectedWOTypes.length ? 'red' : ''">mdi-crosshairs-question</v-icon>
                  </v-btn>
                </template>
                <span v-if='!selectedWOTypes.length' class='caption'>Filter by work order type</span>
                <span v-else class='caption'>woType filter is active</span>
              </v-tooltip>
            </template>
            <v-card tile max-width='300'>
              <v-card-text>
                <v-combobox dense label='Only show WO types:' small-chips multiple :items='availableWOTypes'
                  item-value='id' item-text='name' v-model='selectedWOTypes' clearable hide-details></v-combobox>
              </v-card-text>
            </v-card>
          </v-menu>

          <v-menu offset-y bottom :close-on-content-click='false' :value='showTimelinePicker'>
            <template v-slot:activator='{ on: menu }'>
              <v-tooltip top :open-delay='500'>
                <template v-slot:activator='{ on: tooltip }'>
                  <div v-on='{ ...tooltip }' class='d-inline-block'>
                    <v-btn v-on='{ ...menu }' x-small icon
                      :disabled='isLoading || (!pickableTimelines.length && !selectedTimelines.length)'
                      @click='showTimelinePicker = true'>
                      <v-icon small :color="selectedTimelines.length ? 'red' : ''">mdi-calendar-clock</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span v-if='!selectedTimelines.length' class='caption'>
                  {{ pickableTimelines.length ?
                    "Filter by Timeline (eg BM8)" :
                    "There are no wos with a timeline(egBM8) "
                  }}
                </span>
                <span v-else class='caption'>timeline filter is active</span>
              </v-tooltip>
            </template>
            <v-card tile max-width='300'>
              <v-card-text>
                <v-combobox dense label='Only show timelines:' small-chips multiple :items='pickableTimelines'
                  item-value='id' item-text='name' v-model='selectedTimelines' clearable hide-details></v-combobox>
              </v-card-text>
            </v-card>
          </v-menu>
          <v-menu offset-y bottom :close-on-content-click='false' :value='showPriorityPicker'>
            <template v-slot:activator='{ on: menu }'>
              <v-tooltip top :open-delay='500'>
                <template v-slot:activator='{ on: tooltip }'>
                  <div v-on='{ ...tooltip }' class='d-inline-block'>
                    <v-btn v-on='{ ...menu }' x-small icon
                      :disabled='isLoading || (!pickablePriorities.length && !selectedPriorities.length)'
                      @click='showPriorityPicker = true'>
                      <v-icon small :color="selectedPriorities.length ? 'red' : ''">mdi-calendar-clock</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-tooltip>
            </template>
            <v-card tile max-width='300'>
              <v-card-text>
                <v-combobox dense label='Only show priorities:' small-chips multiple :items='pickablePriorities'
                  item-value='value' item-text='text' v-model='selectedPriorities' clearable hide-details></v-combobox>
              </v-card-text>
            </v-card>
          </v-menu>

          <v-tooltip top :open-delay='500'>
            <template v-slot:activator='{ on }'>
              <v-btn v-on='on' x-small :disabled='isLoading' icon @click='filterByOfficeAlert = !filterByOfficeAlert'>
                <v-icon :color="filterByOfficeAlert ? 'error' : ''" small>mdi-calendar-alert</v-icon>
              </v-btn>
            </template>
            <span class='caption'>{{ filterByOfficeAlert ? "office alert filter is active" : "filter by office alert"
              }}</span>
          </v-tooltip>

          <v-menu offset-y bottom :close-on-content-click='false' :v-model='showSort'>
            <template v-slot:activator='{ on: menu }'>
              <v-tooltip top :open-delay='500'>
                <template v-slot:activator='{ on: tooltip }'>
                  <div v-on='{ ...tooltip, ...menu }' class='d-inline-block'>
                    <v-btn x-small icon :disabled='isLoading' @click='showSort = true'>
                      <v-icon small :color="!sortSelect ? '' : 'red'">mdi-swap-vertical</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span v-if='!sortSelect' class='caption'>Sort WOs</span>
                <span v-else class='caption'>Custom sort has been applied</span>
              </v-tooltip>
            </template>
            <v-card tile max-width='300'>
              <v-card-text>
                Sort by:
                <v-radio-group id='sortRadio' v-model="sortSelect">
                  <v-radio v-for="item in sortItems" :key="item.text" :label="item.text" :value="item.value"></v-radio>
                </v-radio-group>
              </v-card-text>
            </v-card>
          </v-menu>
        </td>
      </tr>
    </table>
    <div class='unscheduled-box'>
      <wo-list v-if='unscheduled.wos' :isLoading='isLoading' :loadingText='loadingText' :items='sortedWOs'
        routeDate='none' :showInsertBox='false' :search='search' @openCrewVisits='openCrewVisits'
        @openQuickView='openQuickView' @woClicked='woClicked' hideScroll hideInsertArrows showPagination></wo-list>
      <wc-loading v-else line></wc-loading>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import WOList from './WOList'
import scheduleServices from '../../services/schedule'

export default {
  name: 'unscheduled',
  props: {
    schedule: {
      required: false
    },
    unscheduled: {
      required: true
    },
    isLoading: {
      required: true
    },
    loadingText: {
      required: false,
      default: 'Loading WOs'
    }
  },
  data: () => ({
    showWOPicker: false,
    filterByCommercial: false,
    filterByParkingLot: false,
    filterByOfficeAlert: false,
    showRouteGroupPicker: false,
    showTimelinePicker: false,
    showPriorityPicker: false,
    showSearch: false,
    sortSelect: null,
    showSort: false,
    search: '',
    headers: [
      { text: '', value: 'wo' }
    ],
    selectedRouteGroups: [],
    selectedWOTypes: [],
    selectedTimelines: [],
    selectedPriorities: [],
    sortItems: [
      { text: 'Project Name - Ascending', value: 'NA' },
      { text: 'Project Name - Descending', value: 'ND' },
      { text: 'Route Order - Ascending', value: 'RA' },
      { text: 'Route Order - Descending', value: 'RD' }
    ]
  }),
  computed: {
    availableWOTypes() {
      let list = scheduleServices.getAvailableWOTypes(this.unscheduled.wos)
      return _.filter(this.$store.state.misc.woTypes, type => _.includes(list, type.id))
    },
    availableRouteGroups() {
      return scheduleServices.getAvailableRouteGroups(this.unscheduled.wos)
    },
    availableTimelines() {
      return scheduleServices.getAvailableTimelines(this.unscheduled.wos)
    },
    pickableTimelines() {
      return _.filter(this.availableTimelines, t => t !== null && t !== "")
    },
    pickablePriorities() {
      return [
        { text: 'Should do', value: 1 },
        { text: 'Must do', value: 2 }
      ]
    },
    pickableRouteGroups() {
      return _.filter(this.availableRouteGroups, r => r !== null && r !== "")
    },
    filterableWOTypes() {
      if (this.selectedWOTypes.length > 0) {
        return this.selectedWOTypes
      }
      return this.availableWOTypes
    },
    filterableRouteGroups() {
      if (this.selectedRouteGroups.length > 0) {
        return this.selectedRouteGroups
      }
      return this.availableRouteGroups
    },
    filterableTimelines() {
      if (this.selectedTimelines.length > 0) {
        return this.selectedTimelines
      }
      return this.availableTimelines
    },
    filterablePriorities() {
      if (this.selectedPriorities.length > 0) {
        let priorities = [];
        for (let i = 0; i < this.selectedPriorities.length; i++) {
          priorities.push(this.selectedPriorities[i].value);
        }
        return priorities;
      }
      return null;
    },
    filteredWOs() {
      let tmp = _.filter(this.unscheduled.wos, u => _.includes(this.filterableRouteGroups, u.project_route_group));
      let tmp2 = _.filter(tmp, u => _.find(this.filterableWOTypes, type => type.id === u.wo_type));
      let tmp3 = _.filter(tmp2, u => _.includes(this.filterableTimelines, u.timeline));
      if (this.filterablePriorities) {
        tmp3 = _.filter(tmp3, u => _.includes(this.filterablePriorities, u.priority));
      }
      let tmp4 = null;
      let tmp5 = null;

      if (this.filterByParkingLot) {
        tmp4 = _.filter(tmp3, u => u.park === true);
      }
      else {
        tmp4 = _.filter(tmp3, u => u.park === false);
      }

      if (this.filterByOfficeAlert) {
        return _.filter(tmp3, u => _.find(u.scheduling_considerations || u.project_scheduling_considerations || u.on_hold))
      }

      if (this.filterByCommercial) {
        tmp5 = _.filter(tmp4, u => u.is_comm === true);
      }
      else {
        tmp5 = _.filter(tmp4, u => u.is_comm === false || u.is_comm === true);
      }

      return tmp5;
    },
    sortedWOs() {
      if (this.sortSelect === 'NA') {
        return _.orderBy(this.filteredWOs, 'project_name', 'asc')
      } else if (this.sortSelect === 'ND') {
        return _.orderBy(this.filteredWOs, 'project_name', 'desc')
      } else if (this.sortSelect === 'RA') {
        return _.orderBy(this.filteredWOs, ['project_route_group', 'project_route_number'], ['asc', 'asc'])
      } else if (this.sortSelect === 'RD') {
        return _.orderBy(this.filteredWOs, ['project_route_group', 'project_route_number'], ['desc', 'desc'])
      }
      return this.filteredWOs
    },
    routeRevenue() {
      return _.sumBy(this.sortedWOs, 'minimum_price')
    },
    searchHint() {
      if (this.selectedRouteGroups.length || this.selectedWOTypes.length) {
        return 'searching filtered list only'
      }
      return 'searching all unscheduled WOs (by name or address)'
    },
    hiddenSelectedWOs() {
      let tmp = _.difference(this.unscheduled.wos, this.filteredWOs)
      return _.some(tmp, ['is_selected', true])
    }
  },
  methods: {
    woClicked(wo) {
      let tmpWO = this.filteredWOs.find(w => w.id === wo.id)
      if (wo.is_selected === true) {
        this.$emit('deselect', [wo])
        tmpWO.is_selected = false
      } else {
        this.$emit('select', [wo])
        tmpWO.is_selected = true
      }
    },
    filterCommercial() {
      this.filterByCommercial = !this.filterByCommercial;
    },
    filterParkingLot() {
      this.filterByParkingLot = !this.filterByParkingLot;
    },
    resetList() {
      this.filterByOfficeAlert = false;
      this.selectedWOTypes = [];
      this.selectedRouteGroups = [];
      this.selectedTimelines = [];
      this.search = '';
      this.sortSelect = null;
      this.showSearch = false;
    },
    selectAll() {
      let tmpWOs = this.sortedWOs.filter(w => w.is_selected === false)
      tmpWOs.forEach(w => w.is_selected = true)
      this.$emit('select', tmpWOs)
    },
    deselectAll() {
      let tmpWOs = this.unscheduled.wos.filter(w => w.is_selected === true)
      tmpWOs.forEach(w => w.is_selected = false)
      this.$emit('deselect', tmpWOs)
    },
    openQuickView(wo) {
      this.$emit('openQuickView', wo)
    },
    openCrewVisits(wo) {
      this.$emit('openCrewVisits', wo)
    },
    openSearch() {
      this.showSearch = true
      setTimeout(() => {
        this.$refs.search.focus()
      }, 100)
    },
    closeSearch() {
      this.showSearch = false
      this.search = ""
    }
  },
  components: {
    'wo-list': WOList
  }
}
</script>

<style>
.unscheduled-box {
  width: 250px !important;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
